export const commonFormatDate = 'DD/MM/YYYY' //format saved in DB
export const curMonth = 'Current Month'

export const initialPage = 1
export const customPageSize = 20

// eslint-disable-next-line
export function formatDate(date: Date): string {
  const day = date.getDate().toString().padStart(2, '0')
  const month = (date.getMonth() + 1).toString().padStart(2, '0')
  const year = date.getFullYear().toString()
  return `${day}/${month}/${year}`
}
